import { useEffect } from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import {
  G2_USERS_LOVE_US_BADGE_ALT,
  G2_USERS_LOVE_US_BADGE_SRC,
  G2_USERS_LOVE_US_REVIEWS_URL,
} from '../../lib/g2PublicStats'
import { ensureG2OfficialRatingSchema } from '../../lib/g2OfficialRatingSchema'

/**
 * Official G2 “Users Love Us” badge (hosted SVG + reviews link + rating JSON-LD).
 */
export function G2UsersLoveUsBadge({
  className = '',
  width = 125,
  injectRatingSchema = true,
}) {
  const { t } = useLanguage()

  useEffect(() => {
    if (injectRatingSchema) ensureG2OfficialRatingSchema()
  }, [injectRatingSchema])

  const rootClass = ['g2-users-love-us-badge', className].filter(Boolean).join(' ')

  return (
    <a
      title={t('trust.g2BadgeLinkTitle')}
      href={G2_USERS_LOVE_US_REVIEWS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={rootClass}
    >
      <img
        alt={G2_USERS_LOVE_US_BADGE_ALT}
        className="g2-users-love-us-badge__img"
        src={G2_USERS_LOVE_US_BADGE_SRC}
        width={width}
        height={Math.round(width * 1.17)}
        loading="lazy"
        decoding="async"
      />
    </a>
  )
}
